<template>
  <div id="index">
    <!-- 加载进度条 -->
    <div id="loading" v-show="$store.state.loading_state &&
      $route.name == 'forest'
      " :style="return_style()">
      <div class="center">
        <div class="bar" :style="{ width: width + '%' }">&nbsp;</div>
      </div>
    </div>
    <div id="map">
      <router-view :style="return_style()"></router-view>
      <!-- 场景导入 -->
      <div id="qtcanvas" v-show="$store.state.isShowCanvas"></div>
    </div>
  </div>
</template>

<script>
let that;
// import CryptoJS from "crypto-js";
export default {
  name: "earth",
  data() {
    return {
      width: 0,
    };
  },
  watch: {
    $route(newValue, oldValue) {
      that.$store.state.sanwei.root = "";
      that.$store.state.root = "";
    }
  },
  methods: {
    // 返回zoom或者transform
    return_style() {
      if (navigator.userAgent.indexOf("Firefox") > -1) {
        return {
          // '-moz-transform':'scale('+this.$store.state.zoom+')',
          // '-moz-transformOrigin':'0 0'
        };
      } else {
        return {
          zoom: this.$store.state.zoom
        };
      }
    },
    // wasm 转 js
    UTF8ToString(addr) {
      let mbuffer = window.Module.asm.memory.buffer
      let buffer = new Uint8Array(mbuffer, addr, mbuffer.byteLength - addr);
      let term = buffer.indexOf(0);
      return new TextDecoder().decode(buffer.subarray(0, term));
    },
    // js 转wasm识别
    allocate(str) {
      let jsonstr1 = Array.from(new TextEncoder().encode(str)).concat(0)
      const ptr = window.Module.asm.malloc(jsonstr1.length);
      window.Module.HEAPU8.set(jsonstr1, ptr);
      return ptr
    },
    async init() {
      let that = this;
      const instance = await qtLoad({
        qt: {
          onLoaded: () => { },
          onExit: exitData => {
            that.width = 0;
            clearInterval(that.timer);
            that.timer_num = setInterval(() => {
              if (that.width > 80) {
                clearInterval(that.timer_num);
              } else {
                that.width += 2;
              }
            }, 100);
          },
          entryFunction: window.createQtAppInstance,
          containerElements: [document.querySelector('#qtcanvas')],
        }
      });
      window.Module = instance;


      that.width = 100;
      clearInterval(that.timer_num);
      that.msg = "加载完成";
      // 关闭地形
      window.Module.asm.Scene_Navigate(allocate(config.cj_sljy));
      window.Module.asm.LoadFont(allocate(config.fontUrl));
    },
    // 绘制临时多边形
    draw_geo(geo, state) {
      window.Module.asm.Scene_ClearTempPolyline();
      geo.coordinates.forEach((val, i) => {
        if (geo.type == "Polygon") {
          this.add_line(val, state);
        } else if (geo.type == "MultiPolygon") {
          val.forEach(v => {
            this.add_line(v, state);
          });
        }
      });
      window.Module.asm.Scene_SetTempPolylineTwinkling(true);
      window.Module.asm.Scene_SetTempPolylineLifeTime(12);
    },
    add_line(v, state) {
      let poly = v;
      if (state == 1) {
        // 左上角区划简化
        if (that.$store.state.quhua.length < 3 || v.length > 2000) {
          // 省市
          let tolerance = 0;
          if (that.$store.state.quhua.length < 3) {
            tolerance = 0.01;
          } else {
            tolerance = 0.001;
          }
          poly = turf.simplify(turf.polygon([v]), {
            tolerance,
            mutate: true
          }).geometry.coordinates[0];
          if (
            that.$store.state.quhua.length < 3 &&
            poly.length < 20
          ) {
            return;
          }
        }
      } else if (state == 2) {
        // 双重区
        poly = turf.simplify(turf.polygon([v]), {
          tolerance: 0.1,
          mutate: true
        }).geometry.coordinates[0];
      }
      // 内圈 顺时针  外环 逆时针
      if (!turf.booleanClockwise(turf.lineString(v)) && state) {
        return;
      }
      window.Module.asm.Scene_BeginTempPolyline(
        0xffff0000,
        6,
        0xffff0000,
        1,
        false
      );
      poly.forEach(arr => {
        window.Module.asm.Scene_AddTempPolyline(arr[0], arr[1], 0);
      });
      window.Module.asm.Scene_EndTempPolyline();
    },
    // 获取当前分辨率下缩放尺寸
    get_screen() {
      let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width < 3000) {
        return 1
      } else if (width < 4000) {
        return 1.5
      } else if (width < 5000) {
        return 2.2
      } else {
        return width / 1920
      }
    },
    detectZoom() {
      let ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();
      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (~ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
  },
  mounted() {
    that = this;
    window.UTF8ToString = this.UTF8ToString
    window.allocate = this.allocate
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      alert("不支持IE浏览器");
      this.msg = "浏览器不支持，无法加载";
    } else {
      that.$store.state.zoom = config.zoom || this.get_screen();
      this.init();
      this.$store.state.sanwei.type_data = this.$route.query.type;
      this.$store.state.draw_geo = this.draw_geo;
      this.$store.state.detectZoom = this.detectZoom;
      // 鼠标侧键禁止
      window.addEventListener("mousedown", e => {
        if (e.button == 3) {
          //鼠标侧键3
          window.history.pushState(null, null, URL);
          return false;
        } else if (e.button == 4) {
          //鼠标侧键4
          window.history.pushState(null, null, URL);
          return false;
        }
      });
      // 防止在其他地方松开鼠标持续原有操作
      window.addEventListener("mouseup", e => {
        if (e.target.id != "qtcanvas") {
          if (window.JSEvents) {
            JSEvents.eventHandlers
              .filter(v => v.eventTypeString == "mouseup")[0]
              .eventListenerFunc(e);
            window.Module.asm.ViewPoint_Stopfly();
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin background {
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-radius: 5px;
}

#index {
  width: 100%;
  height: 100%;
  position: relative;
}

#map {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

#loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2000;
  color: #fff;
  background-color: #D2E7F0;
  // background: url("../../assets/forest/index/bg.png") no-repeat 0 0;
  // background-size: 100% 100%;
  height: 100%;
  width: 100%;

  .center {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 60%;
    max-width: 700px;
    transform: translate(-50%, -50%);
    margin-top: -20px;
  }

  .tip {
    text-align: center;
    font-size: 20px;
    line-height: 30px;
    font-weight: 800;
  }

  .bar {
    height: 18px;
    margin-top: -50px;
    background-color: #009744;
    height: 8px;
    overflow: hidden;
    transition: width 3s;
  }

  .desc {
    text-align: center;
    font-size: 12px;
    line-height: 30px;
  }
}

#qtcanvas {
  border: 0px none;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/earth.vue